import {
  BooleanField,
  ChipField,
  DateField,
  EditButton,
  List as RaList,
  TextField,
} from "react-admin";
import Filters from "./Filters";
import React from "react";
import { Datagrid } from "ra-friendsofbabba";

const List = (props) => {
  return (
    <RaList
      {...props}
      filters={<Filters />}
      perPage={25}
      sort={{ field: "order", order: "asc" }}
    >
      <Datagrid>
        <TextField source="id" label="ID" />
        <TextField
          source="language.name"
          label="resources.pages.fields.language_id"
        />
        <TextField source="name" style={{ fontWeight: "bold" }} />
        <ChipField source="code" style={{ marginLeft: 0 }} />
        <TextField source="order" />
        <BooleanField source="is_menu" />
        <DateField source="modified" showTime />
        <EditButton />
      </Datagrid>
    </RaList>
  );
};
export default List;
